import React from 'react';
import { Video, Users, Clock, Calendar } from 'lucide-react';
import { Meeting } from '../../../types/meeting';
import { formatDate } from '../../../utils/formatters';

interface MeetingsListProps {
  meetings: Meeting[];
  searchTerm: string;
  onJoin: (meetingId: string) => void;
}

export default function MeetingsList({ meetings, searchTerm, onJoin }: MeetingsListProps) {
  const filteredMeetings = meetings.filter(meeting =>
    meeting.topic.toLowerCase().includes(searchTerm.toLowerCase()) ||
    meeting.description?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="divide-y divide-gray-200">
      {filteredMeetings.map((meeting) => (
        <div key={meeting.id} className="p-4 hover:bg-gray-50">
          <div className="flex justify-between items-start">
            <div>
              <div className="flex items-center">
                <Video className="w-4 h-4 text-blue-500 mr-2" />
                <h4 className="text-sm font-medium text-gray-900">
                  {meeting.topic}
                </h4>
              </div>
              {meeting.description && (
                <p className="mt-1 text-sm text-gray-500">{meeting.description}</p>
              )}
              <div className="mt-2 flex items-center space-x-4 text-sm text-gray-500">
                <span className="flex items-center">
                  <Calendar className="w-4 h-4 mr-1" />
                  {formatDate(meeting.startTime)}
                </span>
                <span className="flex items-center">
                  <Clock className="w-4 h-4 mr-1" />
                  {meeting.duration} minutes
                </span>
                <span className="flex items-center">
                  <Users className="w-4 h-4 mr-1" />
                  {meeting.participants} participants
                </span>
              </div>
            </div>
            <button
              onClick={() => onJoin(meeting.id)}
              className="px-3 py-1 text-sm text-blue-600 hover:bg-blue-50 rounded"
            >
              Join
            </button>
          </div>
        </div>
      ))}
      
      {filteredMeetings.length === 0 && (
        <div className="p-4 text-center text-gray-500">
          No meetings found
        </div>
      )}
    </div>
  );
}